const AWA_ONBOARDING_SEEN_KEY = 'gb-awa-onboarding-seen';

// Device-level flag so the migration onboarding shows on the first redirect into
// the email-setup flow and never again. Wrapped in try/catch because Safari
// private mode throws on localStorage access.
export function hasSeenAwaOnboarding(): boolean {
  try {
    return localStorage.getItem(AWA_ONBOARDING_SEEN_KEY) === 'true';
  } catch {
    return false;
  }
}

export function markAwaOnboardingSeen(): void {
  try {
    localStorage.setItem(AWA_ONBOARDING_SEEN_KEY, 'true');
  } catch {
    // Storage unavailable (private mode); the onboarding will show again next visit.
  }
}
